import { useContext } from 'react';
import { Store } from '../Store';
import { Helmet } from 'react-helmet-async';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import MessageBox from '../components/MeaasgeBox';
import { Link, useNavigate } from 'react-router-dom';
import ListGroupItem from 'react-bootstrap/esm/ListGroupItem';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/esm/Button';
import api, { API_BASE_URL } from '../api';
import Container from 'react-bootstrap/Container';
import CardHeader from '../components/CardHeadder';

export default function CartScreen() {
  const navigate = useNavigate();
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const {
    cart: { cartItems },
  } = state;

  const updateCartHandler = async (item, quantity) => {
    const { data } = await api.get(`/api/products/${item._id}`);

    ctxDispatch({
      type: 'CART_ADD_ITEM',
      payload: { ...item, quantity },
    });
  };

  const removeItemHandler = (item) => {
    ctxDispatch({ type: 'CART_REMOVE_ITEM', payload: item });
  };

  const checkoutHandler = () => {
    navigate('/shipping');
  };

  return (
    <div>
      <CardHeader />
      <Container fluid="md" className="mt-3">
        <div className="d-flex justify-content-start">
          <Button
            onClick={() => navigate('/products')}
            style={{
              backgroundColor: '#801001',
              color: 'white',
              border: 'none',
              fontWeight: 'bold',
              padding: '0.5rem 1.2rem',
              fontSize: '1rem',
              borderRadius: '50px',
              transition: 'all 0.3s ease', // smooth animation
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#a0120f'; // slightly lighter red
              e.target.style.boxShadow = '0px 4px 15px rgba(0,0,0,0.2)'; // subtle shadow
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#801001';
              e.target.style.boxShadow = 'none';
            }}
          >
            ← Back to Products
          </Button>
        </div>
      </Container>
      <Container fluid="md" className="mt-3 py-3">
        <div>
          <Helmet>
            <title>Shopping Card</title>
          </Helmet>
          <h1 style={{ fontSize: '2rem', color: '#801001', fontWeight: 'bold' }}>
            Shopping Cart
          </h1>
          <br />
          <Row>
            <Col md={9}>
              {cartItems.length === 0 ? (
                <MessageBox variant="danger">
                  Dear valuable customer, Your Cart is empty.{' '}
                  <Link to="/products" style={{ color: '#801001', fontWeight: 'bold' }}>
                    Go Shopping
                  </Link>
                </MessageBox>
              ) : (
                <ListGroup>
                  {cartItems.map((item) => (
                    <ListGroupItem key={item._id}>
                      <Row className="align-items-center">
                        {/* Image and Name in the Same Line */}
                        <Col md={5} className="d-flex align-items-center gap-3">
                          <img
                            src={item.image ? (item.image.startsWith('http') ? item.image : `${API_BASE_URL}/storage/${item.image}`) : ''}
                            alt={item.name}
                            className="img-fluid rounded img-thumbnail"
                            style={{
                              width: '100px',
                              height: '100px',
                              objectFit: 'cover',
                            }}
                          />
                          <Link
                            className="cardname"
                            to={`/product/${item._id}`}
                          >
                            <strong style={{ color: '#801001' }}>
                              {item.name}
                            </strong>
                          </Link>
                        </Col>

                        {/* ID, Size, Color, Quantity Controls, and Delete Button in the Same Line */}
                        <Col
                          md={7}
                          className="d-flex align-items-center justify-content-between flex-wrap gap-2"
                        >
                          <strong style={{ color: '#801001' }}>
                            ID: {item.code}
                          </strong>
                          {item.selectedSize && (
                            <strong style={{ color: '#801001' }}>
                              Size: {item.selectedSize}
                            </strong>
                          )}
                          {item.selectedColor && (
                            <strong style={{ color: '#801001' }}>
                              Color: {item.selectedColor}
                            </strong>
                          )}

                          {/* Quantity Controls */}
                          <div className="d-flex align-items-center gap-2">
                            <Button
                              style={{ color: '#801001' }}
                              onClick={() =>
                                updateCartHandler(item, item.quantity - 5)
                              }
                              variant="light"
                              disabled={item.quantity <= 5} // Disable if quantity is 5 or less
                            >
                              <i className="fas fa-minus-circle"></i>
                            </Button>
                            <Button
                              style={{ color: '#801001' }}
                              onClick={() =>
                                updateCartHandler(item, item.quantity - 1)
                              }
                              variant="light"
                              disabled={item.quantity === 1}
                            >
                              <i className="fas fa-minus"></i>
                            </Button>
                            <span>{item.quantity}</span>
                            <Button
                              style={{ color: '#801001' }}
                              variant="light"
                              onClick={() =>
                                updateCartHandler(item, item.quantity + 1)
                              }
                            >
                              <i className="fas fa-plus"></i>
                            </Button>
                            <Button
                              style={{ color: '#801001' }}
                              variant="light"
                              onClick={() =>
                                updateCartHandler(item, item.quantity + 5)
                              }
                            >
                              <i className="fas fa-plus-circle"></i>
                            </Button>
                          </div>

                          {/* Remove Button */}
                          <Button
                            style={{ color: '#801001' }}
                            onClick={() => removeItemHandler(item)}
                            variant="light"
                          >
                            <i className="fas fa-trash"></i>
                          </Button>
                        </Col>
                      </Row>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              )}
            </Col>

            <Col md={3}>
              <Card>
                <Card.Body>
                  <ListGroup variant="flush">
                    <ListGroup.Item>
                      <h3 className="text-center" style={{ color: '#801001' }}>
                        Subtotal (
                        {cartItems.reduce((a, c) => a + c.quantity, 0)} items)
                      </h3>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className="d-grid">
                        <Button
                          type="button"
                          style={{
                            backgroundColor: '#801001',
                            color: 'white',
                            border: 'none',
                            fontWeight: 'bold',
                            padding: '0.8rem',
                            transition: 'all 0.3s ease',
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#a0120f';
                            e.target.style.transform = 'scale(1.02)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = '#801001';
                            e.target.style.transform = 'scale(1)';
                          }}
                          onClick={checkoutHandler}
                          disabled={cartItems.length === 0}
                        >
                          Proceed to Checkout
                        </Button>
                      </div>
                    </ListGroup.Item>
                  </ListGroup>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}
